import { PlaceholderValue } from 'next/dist/shared/lib/get-img-props'

// Literal token values (LR surface colors). CSS variables can't resolve inside
// a standalone SVG data URI, so the hex values are inlined here.
const SURFACE_BASE = '#F5F5F5' // surface.base (gray2)
const SURFACE_STRONG = '#F9F9F9' // surface.hover (gray1) — closest to mamyito surface.strong

export const shimmer = (width: number, height: number) => `
<svg width="${width}" height="${height}" version="1.1" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="skeleton-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop stop-color="${SURFACE_BASE}" offset="0%" />
      <stop stop-color="${SURFACE_STRONG}" offset="40%" />
      <stop stop-color="${SURFACE_BASE}" offset="80%" />
    </linearGradient>
  </defs>
  <rect width="${width}" height="${height}" fill="${SURFACE_BASE}" />
  <rect id="skeleton-shimmer" width="${width}" height="${height}" fill="url(#skeleton-gradient)" x="-${width}" />
  <animate
    href="#skeleton-shimmer"
    attributeName="x"
    from="-${width}"
    to="${width}"
    dur="1.2s"
    repeatCount="indefinite"
  />
</svg>`

export const toBase64 = (str: string) =>
  typeof window === 'undefined'
    ? Buffer.from(str).toString('base64')
    : window.btoa(str)

export const getSkeletonImagePlaceholder = (
  width: number,
  height: number
): PlaceholderValue =>
  `data:image/svg+xml;base64,${toBase64(shimmer(width, height))}`
